module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin-left": "0px"
    }
  }, [(_vm.debug_show_page_name == true) ? _c('div', {
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v("sub-table-temp-certificate-information")]) : _vm._e(), _vm._v(" "), _c('div', {
    class: 'container ' + _vm.pageContainerSize
  }, [_c('ag-grid-vue', {
    staticClass: "ag-blue",
    staticStyle: {
      "width": "100%",
      "height": "445px"
    },
    attrs: {
      "gridOptions": _vm.gridOptions
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row ",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('div', {
    staticClass: "col-xs-4"
  }, [_c('span', {
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v("件数")]), _vm._v(" "), _c('input', {
    staticClass: "form-control limited-height-box",
    staticStyle: {
      "margin-left": "5px",
      "float": "left",
      "width": "100px",
      "text-align": "right"
    },
    attrs: {
      "type": "text",
      "data-cy": "totalNumberOfRows",
      "disabled": true
    },
    domProps: {
      "value": _vm.totalNumberOfRows
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-8"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showRetractionReason),
      expression: "showRetractionReason"
    }],
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "5px",
      "padding": "0px 10px"
    }
  }, [_c('label', {
    staticClass: "col-xs-4 control-label esma_form_label"
  }, [_vm._v("差戻理由 ")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-8 select-box4",
    staticStyle: {
      "padding": "1px 0px 0px 7px",
      "margin-bottom": "-15px"
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.retractionReasonValue),
      expression: "retractionReasonValue"
    }],
    staticClass: "form-control",
    staticStyle: {
      "height": "60px !important"
    },
    attrs: {
      "disabled": _vm.disableRetractionReason,
      "placeholder": "",
      "rows": "3"
    },
    domProps: {
      "value": (_vm.retractionReasonValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.retractionReasonValue = $event.target.value
      }
    }
  }), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4 "
  }), _vm._v(" "), _c('div', {
    staticClass: "col-xs-8 ",
    staticStyle: {
      "padding": "0px 0px 20px 7px"
    }
  }, [(_vm.disableRetractionReason == true && _vm.disableEditRetractionReason == false) ? _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "width": "7%",
      "float": "right",
      "margin-right": "0px",
      "background": "#337ab7",
      "margin-top": "30px"
    },
    on: {
      "click": function($event) {
        _vm.disableRetractionReason = false
      }
    }
  }, [_vm._v("編集")]) : _vm._e(), _vm._v(" "), (_vm.disableRetractionReason == false) ? _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "width": "7%",
      "float": "right",
      "margin-right": "0px",
      "background": "#A6A6A6",
      "margin-top": "30px"
    },
    attrs: {
      "disabled": false
    },
    on: {
      "click": function($event) {
        _vm.cancelRetractionReason()
      }
    }
  }, [_vm._v("ｷｬﾝｾﾙ")]) : _vm._e(), _vm._v(" "), (_vm.disableRetractionReason == false) ? _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "width": "7%",
      "float": "right",
      "margin-right": "10px",
      "background": "#337ab7",
      "margin-top": "30px"
    },
    on: {
      "click": function($event) {
        _vm.saveRetractionReason()
      }
    }
  }, [_vm._v("入力完了")]) : _vm._e(), _vm._v(" "), (_vm.disableRetractionReason == true && _vm.disableEditRetractionReason == false) ? _c('span', [_c('span', {
    staticStyle: {
      "float": "right",
      "font-size": "15px",
      "margin-right": "0px",
      "font-weight": "800",
      "margin-top": "-65px",
      "letter-spacing": "1px",
      "color": "red"
    }
  }, [_vm._v("※入力完了後、戻るボタンをクリックして、申請承認画面から差戻をしてください。\n               ")])]) : _vm._e(), _vm._v(" "), (_vm.disableRetractionReason == false) ? _c('span', [_c('span', {
    staticStyle: {
      "float": "right",
      "font-size": "15px",
      "margin-right": "145px",
      "font-weight": "800",
      "margin-top": "-65px",
      "letter-spacing": "1px",
      "color": "red"
    }
  }, [_vm._v("※差戻通知を入力し、入力完了をクリックしてください。(任意)\n               ")])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "5px",
      "padding": "0px 10px"
    }
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticStyle: {
      "color": "white",
      "margin": "2px 0px",
      "padding": "2px 5px",
      "text-align": "end",
      "width": "90%",
      "float": "right",
      "background-color": "orange",
      "display": "none"
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "btn btn-lg btn-primary",
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "href": _vm.downloadUrl,
      "target": _vm.downloadUrl
    }
  }, [_vm._v("出力")]), _vm._v(" "), (_vm.showConfirmedBtn) ? _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "float": "right",
      "margin-right": "20px"
    },
    on: {
      "click": _vm.onRejectedConfirmed
    }
  }, [_vm._v("確認済")]) : _vm._e(), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.countErrors > 0 && _vm.filerByError == false),
      expression: "countErrors > 0 && filerByError == false"
    }],
    staticClass: "btn btn-warning",
    staticStyle: {
      "float": "right",
      "margin-right": "20px"
    },
    on: {
      "click": _vm.filterOnlyErrors
    }
  }, [_vm._v("エラー詳細")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.countErrors > 0 && _vm.filerByError == true),
      expression: "countErrors > 0 && filerByError == true"
    }],
    staticClass: "btn btn-warning",
    staticStyle: {
      "float": "right",
      "margin-right": "20px"
    },
    on: {
      "click": _vm.filterAll
    }
  }, [_vm._v("戻る")])])])])])], 1), _vm._v(" "), _c('confirmation-modal', {
    attrs: {
      "tag": "onRejectedConfirmedModal"
    },
    on: {
      "done": _vm.onRejectedConfirmedStep2
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-78f6b51b","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/sub_pages/sub-table-temp-batch-import.vue
// module id = 1032
// module chunks = 0